/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GenerateRequestedDocUploadUrl_docUploadInfo_DocumentUploadInfo = { readonly __typename: 'DocumentUploadInfo', readonly documentUuid: string, readonly url: string };

export type GenerateRequestedDocUploadUrl_Mutation = { readonly __typename: 'Mutation', readonly docUploadInfo: GenerateRequestedDocUploadUrl_docUploadInfo_DocumentUploadInfo };


export type GenerateRequestedDocUploadUrlVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['String']['input'];
  fileName: _Types.Scalars['String']['input'];
  documentType: _Types.CreditDocument;
}>;


export type GenerateRequestedDocUploadUrl = GenerateRequestedDocUploadUrl_Mutation;


export const GenerateRequestedDocUploadUrlDocument = gql`
    mutation GenerateRequestedDocUploadUrl($creditApplicationId: String!, $fileName: String!, $documentType: CreditDocument!) {
  docUploadInfo: generateDocumentUploadUrl(
    salesforceCreditId: $creditApplicationId
    fileName: $fileName
    documentType: $documentType
  ) {
    documentUuid
    url: presignedUrl
  }
}
    `;
export type GenerateRequestedDocUploadUrlMutationFn = Apollo.MutationFunction<GenerateRequestedDocUploadUrl, GenerateRequestedDocUploadUrlVariables>;

/**
 * __useGenerateRequestedDocUploadUrl__
 *
 * To run a mutation, you first call `useGenerateRequestedDocUploadUrl` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateRequestedDocUploadUrl` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateRequestedDocUploadUrl, { data, loading, error }] = useGenerateRequestedDocUploadUrl({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *      fileName: // value for 'fileName'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useGenerateRequestedDocUploadUrl(baseOptions?: Apollo.MutationHookOptions<GenerateRequestedDocUploadUrl, GenerateRequestedDocUploadUrlVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateRequestedDocUploadUrl, GenerateRequestedDocUploadUrlVariables>(GenerateRequestedDocUploadUrlDocument, options);
      }
export type GenerateRequestedDocUploadUrlHookResult = ReturnType<typeof useGenerateRequestedDocUploadUrl>;
export type GenerateRequestedDocUploadUrlMutationResult = Apollo.MutationResult<GenerateRequestedDocUploadUrl>;
export type GenerateRequestedDocUploadUrlMutationOptions = Apollo.BaseMutationOptions<GenerateRequestedDocUploadUrl, GenerateRequestedDocUploadUrlVariables>;